

const pageStore = {
  namespaced: true,
  state: {
    fileType:null,
  },

  mutations: {
    SET_FILETYPE:(state,value)=>{
      state.fileType = value;
    }
  },

  actions: {
    setFileType({commit},data){
      commit('SET_FILETYPE',data)
    }
  }
}

export default pageStore



// WEBPACK FOOTER //
// ./src/store/modules/pageStore.js